import { AddCategoryRequest } from '@/types/category';
import axios from './categoryInstance';
import { getCompanyId } from '@/utils/getCompanyId'
import { notifyOnboardingStatusChanged } from '@/features/onboarding/events'

export default async function (request: AddCategoryRequest) {
  const companyId = getCompanyId()
  const payload = {
    ...request,
    company_id: companyId
  }
  console.log(payload)
  const response: any = await axios.post(`/categories/`, payload)
  notifyOnboardingStatusChanged()
  return response.data?.data ?? response.data
}
